import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { EvenementService } from '../../services/evenement.service';
import { ArtisteService } from '../../services/artiste.service';
import { EditionService } from '../../services/edition.service';
import { TemoignageService } from '../../services/temoignage.service';
import { Evenement } from '../../models/evenement.model';
import { Edition } from '../../models/edition.model';

@Component({
  selector: 'app-vue-ensemble',
  templateUrl: './vue-ensemble.component.html',
  styleUrls: ['./vue-ensemble.component.css']
})
export class VueEnsembleComponent implements OnInit, AfterViewInit {

  @ViewChild('chartCategories') canvasCategories!: ElementRef<HTMLCanvasElement>;
  @ViewChild('chartSpectateurs') canvasSpectateurs!: ElementRef<HTMLCanvasElement>;

  nombreEvenements = 0;
  nombreArtistes = 0;
  nombreEditions = 0;
  nombreTemoignagesAttente = 0;

  private evenements: Evenement[] = [];
  private editions: Edition[] = [];

  constructor(
    private evenementService: EvenementService,
    private artisteService: ArtisteService,
    private editionService: EditionService,
    private temoignageService: TemoignageService
  ) { }

  ngOnInit(): void {
    this.evenementService.getEvenements().subscribe(data => {
      this.evenements = data;
      this.nombreEvenements = data.length;
      this.dessinerGraphiqueCategories();
    });

    this.artisteService.getArtistes().subscribe(data => this.nombreArtistes = data.length);

    this.editionService.getEditions().subscribe(data => {
      this.editions = data;
      this.nombreEditions = data.length;
      this.dessinerGraphiqueSpectateurs();
    });

    this.temoignageService.getAll().subscribe(data => {
      this.nombreTemoignagesAttente = data.filter(t => t.statut === 'attente').length;
    });
  }

  ngAfterViewInit(): void {
    // Les graphiques sont dessines une fois les donnees chargees (voir ngOnInit)
  }

  private dessinerBarres(canvas: HTMLCanvasElement, donnees: { label: string; valeur: number }[], couleur: string): void {
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const largeur = canvas.width, hauteur = canvas.height;
    ctx.clearRect(0, 0, largeur, hauteur);

    const marge = 30;
    const zoneHauteur = hauteur - marge - 24;
    const maxValeur = Math.max(...donnees.map(d => d.valeur), 1);
    const largeurBarre = (largeur - marge) / donnees.length;

    donnees.forEach((d, i) => {
      const hauteurBarre = (d.valeur / maxValeur) * zoneHauteur;
      const x = marge + i * largeurBarre + largeurBarre * 0.15;
      const y = zoneHauteur - hauteurBarre + 10;
      const largeurReelle = largeurBarre * 0.7;

      ctx.fillStyle = couleur;
      ctx.fillRect(x, y, largeurReelle, hauteurBarre);

      ctx.fillStyle = '#333';
      ctx.font = '11px Arial';
      ctx.textAlign = 'center';
      ctx.fillText(String(d.valeur), x + largeurReelle / 2, y - 6);

      ctx.fillStyle = '#888';
      ctx.font = '10px Arial';
      ctx.fillText(d.label, x + largeurReelle / 2, zoneHauteur + 24);
    });

    ctx.strokeStyle = '#ddd';
    ctx.beginPath();
    ctx.moveTo(marge, zoneHauteur + 10);
    ctx.lineTo(largeur, zoneHauteur + 10);
    ctx.stroke();
  }

  dessinerGraphiqueCategories(): void {
    if (!this.canvasCategories) return;
    const categories = ['Musique', 'Théâtre', 'Danse', 'Cinéma'];
    const donnees = categories.map(cat => ({
      label: cat,
      valeur: this.evenements.filter(e => e.categorie === cat).length
    }));
    this.dessinerBarres(this.canvasCategories.nativeElement, donnees, '#c9a24b');
  }

  dessinerGraphiqueSpectateurs(): void {
    if (!this.canvasSpectateurs) return;
    const donnees = [...this.editions]
      .sort((a, b) => b.annee - a.annee)
      .slice(0, 5)
      .reverse()
      .map(ed => ({ label: String(ed.annee), valeur: ed.nbSpectateurs }));
    this.dessinerBarres(this.canvasSpectateurs.nativeElement, donnees, '#e0663f');
  }
}
